
// 新人狂赏，查询活动信息用的actListId
export const CActListId = 'H7v8pjePaJCGsqjb3UGIsl1lZWe1a%2B2Pdwz2I20rSVU%3D';

// 新人狂赏新老用户，summer_prom_index.cgi active_user_flag
export const CHotactUser = {
  new: '0',
  old: '1',
};
// 新人狂赏，券状态
export const CHotactCouponState = {
  raw: '0', // 未领取
  usable: '1',    // 已领取未使用
  used: '2',  // 已使用
  expired: '3', // 3：已过期
};
// 新人狂赏，领取状态
export const CHotactReceiveState = {
  success: '0',   // 0-活动执行成功
  fail: '1',  // 1-活动执行失败，内部错误
  notMet: '2',    // 2-不满足领取条件（黑名单）
  noLeft: '3',    // 3-活动库存不足、个人库存不足
  noRight: '4',   // 4-用户没有资格（抽奖专用）
  rightUsed: '5', // 5-资格已使用（抽奖专用）
  rightNotEnough: '6',   // 6-资格数量不足（印花专用）
  other: '99',    // 99-其他出错情况，内部错误
};

/** 路由name */
export enum ERouteName {
  /** 抢券有So首页-券列表 */
  weCouponsList = 'weCouponsList',
  /** 聚合首页抢券有So-券列表 */
  homeWeCouponsList = 'homeWeCouponsList',
  /** 抢券有So首页-商户列表 */
  weCouponsSpList = 'weCouponsSpList',
  /** 抢券有So搜索页 */
  couponsSearch = 'couponsSearch',
};

/** Channel页链接 */
export const CHANNEL_PAGE_URL = 'https://prom.wechatpay.com.hk/merchant-channel/index.shtml';
